import {BroadcastChannel} from 'broadcast-channel';

export const logoutChannel = new BroadcastChannel<string>('logout');
export const loginChannel = new BroadcastChannel<string>('login');
